const BankFormStatus = {
	PENDING: 0,
	PROCESSING: 1,
	APPROVED: 2,
	UNAPPROVED: 3,
	BLOCKED: 4,
};

export default BankFormStatus;
